import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=3275a08a&scoped=true"
import script from "./Money.vue?vue&type=script&lang=js"
export * from "./Money.vue?vue&type=script&lang=js"
import style0 from "./Money.vue?vue&type=style&index=0&id=3275a08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275a08a",
  null
  
)

export default component.exports